import { Trans, useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../components/patch-invite-form';
import { AnySpecialistCard, SpecialistCard } from '../../components/specialist-card';
import { useEnrichedInvite } from '../../hooks/use-enriched-invite.js';

export const schema = z.object({
  specialistId: z.string().min(1),
});

function extractDefaults({ specialistId }, invite) {
  return {
    specialistId:
      specialistId ??
      (invite.practitioners.length === 1 ? invite.practitioners[0].practitionerId : 'any'),
  };
}

function transformValues({ specialistId }) {
  return { specialistId };
}

export function Specialist(props) {
  const { t } = useTranslation(['page.specialist']);
  const invite = useEnrichedInvite();
  const isSingleSpecialist = invite.practitioners.length === 1;
  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props}>
        <h1 className="title">{t(isSingleSpecialist ? 'titleSingle' : 'titleMultiple')}</h1>
        <Trans
          i18nKey={isSingleSpecialist ? 'textSingle' : 'textMultiple'}
          t={t}
          values={invite}
          components={{
            p: <p />,
            h3: <h3 className="subtitle mb-0" />,
          }}
        />
        <div className="group/specialists" data-single-specialist={isSingleSpecialist}>
          <AnySpecialistCard name="specialistId" />
          {invite.practitioners
            .filter((practitioner) => practitioner.calendarSlots?.length > 0)
            .map((specialist) => (
              <SpecialistCard
                key={specialist.practitionerId}
                name="specialistId"
                specialist={specialist}
              />
            ))}
        </div>
      </ProgressLayout>
    </PatchInviteForm>
  );
}
